module.exports = __webpack_public_path__ + "img/licence.a46283ee.png";